<template>
  <scheduled-reports-list
    v-if="selectedDomain.id"
    :tier="tierType"
    :id="selectedDomain.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ScheduledReportsList from "@/views/Common/Reports/Scheduled/List/index.vue";

import { TIER } from "@/constants";

export default {
  name: "ScheduledReportsWrapper",
  components: {
    ScheduledReportsList,
  },
  data() {
    return {
      tierType: TIER.domains,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Scheduled Reports"));

    this.setPageSubtitle([]);
  },
};
</script>
